var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.news.blobUrl,"width":"489px;","height":"280px"},on:{"click":function($event){return _vm.navigateTo(_vm.renderModel.url)}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }